module.exports = __webpack_public_path__ + "img/asuka111-geisha.9cd94ca.jpg";